// Is this page open inside another app's built-in browser (Facebook, Instagram,
// TikTok) rather than Safari or Chrome?
//
// Those apps put their own name in the user agent, and nothing else tells them
// apart: the page can't ask the browser. The tokens are the same list the TTM
// checkout uses (shared-ui utils/in-app-browser.js), so the two brands agree on
// what counts. If a customer reports "checkout broken in [some other app]", add
// that app's token here.
const IN_APP_BROWSER_UA_TOKENS = [
  'Instagram',   // Instagram WebView
  'FBAN',        // Facebook Application Name (iOS)
  'FBAV',        // Facebook Application Version (iOS and Android)
  'FB_IAB',      // Facebook In-App Browser (Android)
  'MusicalLy',   // TikTok legacy token
  'TikTok',      // TikTok current
  'Bytefulapp',  // ByteDance app suite
];

export function isInAppBrowser(ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  const lower = String(ua || '').toLowerCase();
  return IN_APP_BROWSER_UA_TOKENS.some((token) => lower.includes(token.toLowerCase()));
}
